import { create } from 'zustand';

const useMarketingDetailStore = create((set) => ({
    // Holds the current marketing detail data
    marketingDetail: {},

    // Replace the entire marketing detail object
    setMarketingDetail: (newDetail) => set({ marketingDetail: newDetail }),

    // Reset to an empty object
    clearMarketingDetail: () => set({ marketingDetail: {} }),
}));

export default useMarketingDetailStore;
